module.exports = __webpack_public_path__ + "static/media/help-centre-banner.6bc04a65.png";